/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

/** Money is stored as paise (integer); the UI renders Indian Rupees. */
const INR = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
});

/** Render a paise amount as `₹1,23,456.00` (Indian digit grouping). */
export function formatInr(paise: number): string {
  return INR.format(paise / 100);
}

/** Convert a rupee amount (form input) to integer paise for the API. */
export function rupeesToPaise(rupees: number): number {
  return Math.round(rupees * 100);
}
